import React, { useState } from 'react';
import '../styles/Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header-wrapper">
        <div className="header-container">
          <a href="#home" className="logo-brand">
            <img src="/images/logo.png" alt="Taxi 24hrs Logo" className="header-logo-img" />
            <span className="header-logo-text">Taxi 24hr</span>
          </a>

          <button
            type="button"
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((prev) => !prev)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`nav-wrapper ${isMenuOpen ? 'open' : ''}`}>
            <ul className="nav-menu">
              <li><a href="#home" className="nav-link" onClick={closeMenu}>Home</a></li>
              <li><a href="#about" className="nav-link" onClick={closeMenu}>About Us</a></li>
              <li><a href="#services" className="nav-link" onClick={closeMenu}>Our Services</a></li>
              <li><a href="#transfers" className="nav-link" onClick={closeMenu}>Airport Transfers</a></li>
              <li><a href="#contact" className="nav-link" onClick={closeMenu}>Contact Us</a></li>
            </ul>
          </nav>

          {isMenuOpen ? <button type="button" className="menu-backdrop" onClick={closeMenu} aria-label="Close navigation menu"></button> : null}
        </div>
      </div>
    </header>
  );
};

export default Header;
